<template>
  <v-card>
    <form data-vv-scope="filterForm">
      <v-expansion-panel expand :value="[true]">
        <v-expansion-panel-content>
          <div slot="header">
            <v-icon>mdi-filter-variant</v-icon> Filters
          </div>
          <v-card>
            <v-card-text>
              <v-container fluid grid-list-lg>
                <v-layout row wrap>
                  <v-flex xl3 lg4 xs6>
                    <v-autocomplete data-vv-scope="filterForm" :items="tempRiskList" v-model="filters.riskNo" :label="filtersLabel.riskNo" item-text="label" item-value="value" clearable></v-autocomplete>
                  </v-flex>
                  <v-flex xl3 lg4 xs6>
                    <cal-picker data-vv-scope = "filterForm" :label="filtersLabel.effDate" v-model="filters.effDate"></cal-picker>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="red darken-1" flat="flat" @click.native="doClearFilters">Clear Filters</v-btn>
              <v-btn color="primary" flat="flat" type="submit" @click.prevent="doFilters">Apply Filters</v-btn>
            </v-card-actions>
          </v-card>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </form>
    <v-flex xs12>
      <v-layout row>
        <v-flex xs12 class="mt-3">
          <message :messages="messages"></message>
        </v-flex>
        <v-spacer></v-spacer>
        <v-menu offset-x :nudge-left="370" :close-on-content-click="false" :min-width="300" :max-height="400">
          <v-btn color="secondary" class="white--text" slot="activator">
            <span>Columns</span>
            <v-icon right dark>mdi-table-column-plus-after</v-icon>
          </v-btn>
          <v-card>
            <v-card-text>
              <template v-if="columns.length > 0">
                <v-checkbox v-for="column in columns" :key="column.value" :label="column.text" :value="column.value" v-model="selectedColumns"></v-checkbox>
              </template>
              <template v-else>
                No column found
              </template>
            </v-card-text>
          </v-card>
        </v-menu>
      </v-layout>
    </v-flex>
    <v-data-table v-bind:headers="listHeaders" v-bind:items="items" v-bind:search="search" :rows-per-page-items="itemsPerPage" v-bind:pagination.sync="pagination" item-key="index" :loading="loading" :no-data-text="noDataText" :filter="customSearch">
      <template slot="items" slot-scope="props">
        <td v-for="column in selectedColumns" :key="column">
          {{props.item[column]}}
        </td>
        <td class="text-xs-right">
          <table-action :rowData="props" review @review="doReview" remove @remove="doPromptRemove(props.item)"></table-action>
        </td>
      </template>
    </v-data-table>
    <v-btn color="primary" dark class="mb-2" @click="doNew" v-if="checkRisk">New Optional Coverage<v-icon>mdi-plus</v-icon></v-btn>
    <v-dialog v-model="reviewDialog" max-width="900px" persistent>
      <v-card>
        <v-card-title v-if="newCover">
          <span class="headline">New Optional Coverage</span>
        </v-card-title>
        <v-card-title v-else>
          <span class="headline">Optional Coverage</span>
        </v-card-title>
        <form data-vv-scope = "coverForm">
          <v-card-text>
            <message :messages="messages"></message>
            <v-container fluid grid-list-lg>
              <v-layout row wrap  v-if="newCover">
                <v-flex xs6>
                  <v-autocomplete data-vv-scope = "coverForm" :items="riskList" v-model="coverForm.riskNo" :label="labels.riskNo" data-vv-name="riskNo" :data-vv-as="labels.riskNo" :error-messages="errors.collect('coverForm.riskNo')" v-validate="'required'" @input="doItemList(coverForm.riskNo)"></v-autocomplete>
                </v-flex>
                <v-flex xs6>
                  <v-autocomplete data-vv-scope = "coverForm" :items="itemList" v-model="coverForm.itemNo" :label="labels.itemNo" item-text="label" item-value="value" data-vv-name="itemNo" :data-vv-as="labels.itemNo" :error-messages="errors.collect('coverForm.itemNo')" v-validate="'required'" :loading="itemLoading"></v-autocomplete>
                </v-flex>
                <v-flex xs4>
                  <cal-picker data-vv-scope = "coverForm" :label="labels.effDate" v-model="coverForm.effDate" :error-messages="errors.collect('coverForm.effDate')" data-vv-name="effDate" :data-vv-as="labels.effDate" v-validate="'required'"></cal-picker>
                </v-flex>
                <v-flex xs4>
                  <cal-picker data-vv-scope = "coverForm" :label="labels.expDate" v-model="coverForm.expDate" :error-messages="errors.collect('coverForm.expDate')" data-vv-name="expDate" :data-vv-as="labels.expDate"></cal-picker>
                </v-flex>
                <v-flex xs4>
                  <v-checkbox data-vv-scope = "coverForm" :label="labels.allowSi" v-model="coverForm.allowSi"></v-checkbox>
                </v-flex>
              </v-layout>
              <v-layout row wrap v-else>
                <v-flex xs6>
                  <v-subheader class="queryLabel">{{labels.riskNo}}</v-subheader>
                  <div class="title">{{coverForm.riskNo}}</div>
                </v-flex>
                <v-flex xs6>
                  <v-subheader class="queryLabel">{{labels.itemNo}}</v-subheader>
                  <div class="title">{{coverForm.itemNo}}</div>
                </v-flex>
                <v-flex xs6>
                  <v-subheader class="queryLabel">{{labels.effDate}}</v-subheader>
                  <div class="title">{{formatDate(coverForm.effDate)}}</div>
                </v-flex>
                <v-flex xs6>
                  <!-- space -->
                </v-flex>
                <v-flex xs6>
                  <cal-picker data-vv-scope = "coverForm" :label="labels.expDate" v-model="coverForm.expDate" :error-messages="errors.collect('coverForm.expDate')" data-vv-name="expDate" :data-vv-as="labels.expDate"></cal-picker>
                </v-flex>
                <v-flex xs6>
                  <v-checkbox data-vv-scope = "coverForm" :label="labels.allowSi" v-model="coverForm.allowSi"></v-checkbox>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs6>
                  <v-text-field data-vv-scope="coverForm" v-model="coverForm.minSi" v-num-mask="{negative: true, intScale: 16, decScale: 2}" :label="labels.minSi" :error-messages="errors.collect('coverForm.minSi')" data-vv-name="minSi" :data-vv-as="labels.minSi" v-validate="maxValidation(coverForm.maxSi)"></v-text-field>
                </v-flex>
                <v-flex xs6>
                  <v-text-field data-vv-scope="coverForm" v-model="coverForm.maxSi" v-num-mask="{negative: true, intScale: 16, decScale: 2}" :label="labels.maxSi" :error-messages="errors.collect('coverForm.maxSi')" data-vv-name="maxSi" :data-vv-as="labels.maxSi" v-validate="minValidation(coverForm.minSi)"></v-text-field>
                </v-flex>
                <v-flex xs6>
                  <v-text-field data-vv-scope="coverForm" v-model="coverForm.incSi" v-num-mask="{negative: true, intScale: 8, decScale: 2}" :label="labels.incSi" :error-messages="errors.collect('coverForm.incSi')" data-vv-name="incSi" :data-vv-as="labels.incSi"></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" flat @click.native="doClose">Cancel</v-btn>
            <v-btn color="primary" flat type="submit" :loading="submitting" @click.prevent="doSavecoverForm">
              {{newCover ? 'Save Optional Coverage' : 'Update Optional Coverage'}}
              <v-icon right>{{newCover ? 'mdi-plus' : 'mdi-content-save'}}</v-icon>
            </v-btn>
          </v-card-actions>
        </form>
      </v-card>
    </v-dialog>
    <confirm v-model="promptRemove" @ok="doRemove">
      Are you sure that you want to delete the selected Coverage?
      <div class="title">{{deleteCover}}</div>
    </confirm>
  </v-card>
</template>

<script>
import { listMixin } from '@/components/parameters/reusable/listMixins'
import { filterQuery, expandURI } from '@/utils/ajax'
import MessageMixin from '@/mixins/message'
import FieldMixin from '@/mixins/field'
import { removeFormatNumber, formatDisplayNumber } from '@/utils/number.js'
import { extractMenu } from '@/utils/extract'
export default {
  data() {
    return {
      columns: [
        { text: 'Risk', value: 'riskNo' },
        { text: 'Item', value: 'itemNo' },
        { text: 'Effective Date', value: 'effDate' },
        { text: 'Expired Date', value: 'expDate' },
        { text: 'Allow Sum Insured', value: 'allowSi' },
        { text: 'Min Sum Insured', value: 'minSi' },
        { text: 'Max Sum Insured', value: 'maxSi' },
        { text: 'Increase Sum Insured', value: 'incSi' }
      ],
      selectedColumns: ['riskNo', 'itemNo', 'effDate'],
      pagination: {
        sortBy: 'effDate'
      },
      filtersLabel: {
        riskNo: 'Risk No',
        itemNo: 'Item No',
        effDate: 'Effective Date',
        expDate: 'Expired Date',
        allowSi: 'Allow Sum Insured',
        minSi: 'Min Sum Insured',
        maxSi: 'Max Sum Insured',
        incSi: 'Increase Sum Insured'
      },
      filters: {
        riskNo: null,
        itemNo: null,
        effDate: null,
        expDate: null,
        allowSi: null,
        minSi: null,
        maxSi: null,
        incSi: null
      },
      labels: {
        scheme: 'Scheme',
        riskNo: 'Risk No*',
        itemNo: 'Item No*',
        effDate: 'Effective Date*',
        expDate: 'Expired Date',
        allowSi: 'Allow Sum Insured',
        minSi: 'Min Sum Insured',
        maxSi: 'Max Sum Insured',
        incSi: 'Increase Sum Insured'
      },
      coverForm: {
        scheme: null,
        riskNo: null,
        itemNo: null,
        effDate: null,
        expDate: null,
        allowSi: false,
        minSi: 0,
        maxSi: 0,
        incSi: 0
      },
      loading: null,
      submitting: false,
      totalItems: 0,
      reviewDialog: false,
      newCover: false,
      riskList: [],
      itemList: [],
      itemLoading: false,
      showDetailFilters: false,
      deleteCover: '',
      promptRemove: false,
      menu: [],
      riskLoading: [],
      tempRiskList: [],
      checkRisk: false
    }
  },
  computed: {
    schemeMenu() {
      return this.$store.state.parameters.scheme.schemeMenu
    }
  },
  watch: {
    // For pagination, we dont want to watch all the pagination property using deep (shown in vuetify eg)
    // This way the application will load multiple times at the start (when setting totalElements etc)
    'pagination.descending': function (value) {
      this.fetchData(false)
    },
    'pagination.page': function (value) {
      this.fetchData(false)
    },
    'pagination.rowsPerPage': function (value) {
      this.fetchData(false)
    },
    'pagination.sortBy': function (value) {
      this.fetchData(false)
    }
  },
  methods: {
    minValidation(value) {
      const min = removeFormatNumber(value)
      return 'mask_min_value:' + min
    },
    maxValidation(value) {
      const max = removeFormatNumber(value)
      return 'mask_max_value:' + max
    },
    async fetchData(options) {
      if (this.schemeMenu.init !== 1) {
        await this.$store.dispatch('schemeMenuInit', this.scheme)
        await this.doRiskList()
      }
      this.loading = true
      const apiURI = this.schemeMenu.menu.pkgOptCvrs
      const { page, rowsPerPage } = this.pagination
      if (apiURI) {
        try {
          const expand = {
            scheme: this.scheme,
            effDate: this.filters.effDate,
            page: page - 1,
            size: rowsPerPage
          }
          const result = await this.$http.get(filterQuery(expandURI(apiURI, expand), null, this.pagination.sortBy, this.pagination.descending))
          const { data } = result.data
          if (data) {
            this.tempRiskList = []
            this.items = []
            data.map((cover) => {
              const tempList = cover.riskNo
              const convertList = {
                scheme: cover.scheme,
                riskNo: cover.riskNo,
                itemNo: cover.itemNo,
                effDate: this.formatDate(cover.effDate),
                expDate: this.formatDate(cover.expDate),
                allowSi: cover.allowSi,
                minSi: formatDisplayNumber(cover.minSi),
                maxSi: formatDisplayNumber(cover.maxSi),
                incSi: formatDisplayNumber(cover.incSi)
              }
              this.tempRiskList.push(tempList)
              this.items.push(convertList)
            })
            this.loading = false
          } else {
            this.loading = false
            this.items = []
          }
        } catch (err) {
          this.loading = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      } else {
        this.errorMessage('Invalid API Url')
      }
    },
    doClearFilters() {
      this.filters.scheme = this.scheme
      this.filters.riskNo = null
      this.filters.itemNo = null
      this.filters.effDate = null
      this.filters.expDate = null
      this.filters.minSi = null
      this.filters.maxSi = null
      this.filters.incSi = null
      this.fetchData(false)
    },
    doFilters() {
      this.resetMessages()
      this.$validator.validateAll('filterForm').then(result => {
        if (result) {
          // Reset to page 1
          this.pagination.page = 1
          this.fetchData(false)
        }
      })
    },
    async doReview(item) {
      // Init Form
      const apiURI = this.schemeMenu.menu.pkgOptCvr
      if (apiURI) {
        try {
          const expand = {
            scheme: item.item.scheme,
            riskNo: item.item.riskNo,
            itemNo: item.item.itemNo
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result.data
          if (data) {
            this.coverForm.riskNo = data.pkgOptCvr.riskNo
            this.coverForm.itemNo = data.pkgOptCvr.itemNo
            this.coverForm.effDate = data.pkgOptCvr.effDate
            this.coverForm.expDate = data.pkgOptCvr.expDate
            this.coverForm.allowSi = data.pkgOptCvr.allowSi
            this.coverForm.minSi = formatDisplayNumber(data.pkgOptCvr.minSi)
            this.coverForm.maxSi = formatDisplayNumber(data.pkgOptCvr.maxSi)
            this.coverForm.incSi = formatDisplayNumber(data.pkgOptCvr.incSi)
            this.menu = extractMenu(result.data._links)
            this.reviewDialog = true
            this.newCover = false
          }
        } catch (error) {
          const { data } = error.response
          if (data) {
            this.message(data)
          }
        }
      } else {
        this.errorMessage('Invalid API Url')
      }
    },
    doClearForm() {
      this.coverForm.scheme = this.scheme
      this.coverForm.riskNo = null
      this.coverForm.itemNo = null
      this.coverForm.effDate = null
      this.coverForm.expDate = null
      this.coverForm.allowSi = false
      this.coverForm.minSi = 0.00
      this.coverForm.maxSi = 0.00
      this.coverForm.incSi = 0.00
    },
    doNew() {
      this.doClearForm()
      this.newCover = true
      this.reviewDialog = true
    },
    doClose() {
      this.resetValidator()
      this.resetMessages()
      this.doClearForm()
      this.newCover = false
      this.reviewDialog = false
    },
    doSavecoverForm() {
      this.resetMessages()
      this.$validator.validateAll('coverForm').then(result => {
        if (result) {
          if (this.newCover) {
            this.doCreate()
          } else {
            this.doUpdate()
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doCreate() {
      const apiURI = this.schemeMenu.menu.pkgOptCvrCreate
      if (apiURI) {
        try {
          const formatForm = {
            scheme: this.scheme,
            riskNo: this.coverForm.riskNo,
            itemNo: this.coverForm.itemNo,
            effDate: this.coverForm.effDate,
            expDate: this.coverForm.expDate,
            allowSi: this.coverForm.allowSi,
            minSi: removeFormatNumber(this.coverForm.minSi),
            maxSi: removeFormatNumber(this.coverForm.maxSi),
            incSi: removeFormatNumber(this.coverForm.incSi)
          }
          const result = await this.$http.post(apiURI, formatForm)
          const { data } = result
          if (data) {
            this.notify(data)
            this.doClose()
            this.fetchData(true)
          }
        } catch (error) {
          console.log(error)
          const { data } = error.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    async doUpdate() {
      try {
        const apiURI = this.menu.pkgOptCvrUpdate
        if (apiURI) {
          const formatForm = {
            scheme: this.scheme,
            riskNo: this.coverForm.riskNo,
            itemNo: this.coverForm.itemNo,
            effDate: this.coverForm.effDate,
            expDate: this.coverForm.expDate,
            allowSi: this.coverForm.allowSi,
            minSi: removeFormatNumber(this.coverForm.minSi),
            maxSi: removeFormatNumber(this.coverForm.maxSi),
            incSi: removeFormatNumber(this.coverForm.incSi)
          }
          const result = await this.$http.put(apiURI, formatForm)
          const { data } = result
          if (data) {
            this.notify(data)
            this.doClose()
            this.fetchData(true)
          }
        }
      } catch (error) {
        const { data } = error.response
        if (data) {
          this.message(data)
          this.fieldMessage(data)
        }
      }
    },
    async doRiskList() {
      this.resetMessages()
      if (this.schemeMenu.init !== 1) {
        await this.$store.dispatch('schemeMenuInit', this.scheme)
        await this.doRiskList()
      }
      const apiURI = this.schemeMenu.menu.riskCoverList
      if (apiURI) {
        try {
          const expand = {
            scheme: this.scheme
          }
          this.riskLoading = true
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result.data
          if (data) {
            this.riskList = data.riskList
            console.log(this.riskList)
            if (this.riskList.length > 0) {
              this.checkRisk = true
            }
          } else {
            this.riskList = []
            this.message(result.data)
          }
          this.riskLoading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      } else {
        this.errorMessage('Invalid API URL - Risk List')
      }
    },
    async doItemList(xriskNo) {
      this.resetMessages()
      const apiURI = this.schemeMenu.menu.itemCoverList
      if (apiURI) {
        try {
          const expand = {
            scheme: this.scheme,
            riskNo: xriskNo
          }
          this.itemLoading = true
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result.data
          if (data) {
            this.itemList = data.itemList
          } else {
            this.itemList = []
            this.message(result.data)
          }
          this.itemLoading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      } else {
        this.errorMessage('Invalid API URL - Risk List')
      }
    },
    doPromptRemove(data) {
      if (data) {
        this.promptRemove = true
        this.selectedCover = data
        this.deleteCover = data.riskNo + ' - ' + data.itemNo
      }
    },
    async doRemove() {
      const apiURI = this.schemeMenu.menu.pkgOptCvrDelete
      if (apiURI) {
        this.loading = true
        const formatForm = {
          scheme: this.scheme,
          riskNo: this.selectedCover.riskNo,
          itemNo: this.selectedCover.itemNo,
          effDate: this.removeFormatDate(this.selectedCover.effDate),
          expDate: this.removeFormatDate(this.selectedCover.expDate),
          allowSi: this.selectedCover.allowSi,
          minSi: removeFormatNumber(this.selectedCover.minSi),
          maxSi: removeFormatNumber(this.selectedCover.maxSi),
          incSi: removeFormatNumber(this.selectedCover.incSi)
        }
        try {
          const result = await this.$http.post(apiURI, formatForm)
          this.notify(result.data)
          // Reinit
          this.fetchData(true)
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.loading = false
        }
      } else {
        this.$snotify.error('Invalid API URL - Delete Optional Coverage')
      }
    },
    removeFormatDate(date) {
      if (date === null) {
        return null
      } else if (date === undefined) {
        return null
      } else if (date === '') {
        return null
      } else {
        var dateString = date
        var dateParts = dateString.split('/')
        return new Date(dateParts[2], dateParts[1] - 1, dateParts[0])
      }
    }
  },
  mounted() {
    this.doRiskList()
  },
  created() {
    this.fetchData(true)
  },
  props: {
    scheme: {
      type: String,
      default: null
    }
  },
  mixins: [
    listMixin,
    MessageMixin,
    FieldMixin
  ]
}
</script>

<style>

</style>
